import { Grid, InputLabel, Card, CardContent, Box } from "@material-ui/core";
import React from "react";
import { TemplateType } from "../../../common/enum";
import AudioFileModel from "../../../models/RequestForHelpTemplates/AudioFileModel";
import FileUpload from "../../BatchNotification/FileUpload/FileUpload";
import "./../IVRFlowConfiguration/IVRFlowConfiguration.css";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

interface MultiAudioUploadWidgetProp {
	title: string;
	rowKey: string;
	partitionKey: string;
	widgetLanguageDetail: AudioFileModel[];
	selectedLanguageList: string[];
	handleAudioFileDetailChange: (audioFileDetail: AudioFileModel) => void;
}

export const MultiAudioUploadWidget: React.FC<MultiAudioUploadWidgetProp> = ({
	title,
	rowKey,
	partitionKey,
	widgetLanguageDetail,
	selectedLanguageList,
	handleAudioFileDetailChange,
}) => {
	const strings = useGetComponentStringsContext().MultiLanguageWidget;

	const handleAudioFileChange = (
		language: string,
		fileUrl: string = "",
		fileName: string = "",
		audioDuration: number = 0
	) => {
		const audioFileDetail: AudioFileModel = {
			value: fileUrl,
			fileName: fileName,
			audioDuration: audioDuration,
			language: language,
		};
		handleAudioFileDetailChange(audioFileDetail);
	};

	return (
		<Grid item xs={12} className="languageWidgetGrid">
			<InputLabel className="labelHeader">{title}</InputLabel>
			<Card className="errorTextDiv">
				<CardContent>
					{selectedLanguageList &&
						selectedLanguageList.length > 0 &&
						selectedLanguageList.map((language: string, index: number) => (
							<Grid item xs={12} key={index}>
								<InputLabel>
									{title + strings.languageTitle1 + language}
								</InputLabel>
								<Box mt={1} mb={2}>
									<FileUpload
										key={index}
										message={
											widgetLanguageDetail.find(
												(el) => el.language === language
											)?.value!
										}
										index={`${"AudioUpload" + title + index}`}
										audioDuration={
											widgetLanguageDetail.find(
												(el) => el.language === language
											)?.audioDuration!
										}
										fileName={
											widgetLanguageDetail.find(
												(el) => el.language === language
											)?.fileName
										}
										removeUploadedFile={() => handleAudioFileChange(language)}
										partitionKey={partitionKey}
										rowKey={rowKey}
										templateType={TemplateType.RequestForHelp}
										onFileChange={(
											fileUrl: string,
											fileName: string,
											audioDuration: number
										) => {
											handleAudioFileChange(
												language,
												fileUrl,
												fileName,
												audioDuration ?? 0
											);
										}}
									></FileUpload>
								</Box>
							</Grid>
						))}
					{selectedLanguageList && !selectedLanguageList.length && (
						<Grid item xs={12}>
							<Box mt={1} mb={2}>
								<FileUpload
									message={widgetLanguageDetail[0]?.value}
									index={`${"AudioUpload" + title}`}
									audioDuration={widgetLanguageDetail[0]?.audioDuration}
									fileName={widgetLanguageDetail[0]?.fileName}
									removeUploadedFile={() => handleAudioFileChange("")}
									partitionKey={partitionKey}
									rowKey={rowKey}
									templateType={TemplateType.RequestForHelp}
									onFileChange={(
										fileUrl: string,
										fileName: string,
										audioDuration: number
									) => {
										handleAudioFileChange(
											"",
											fileUrl,
											fileName,
											audioDuration ?? 0
										);
									}}
								></FileUpload>
							</Box>
						</Grid>
					)}
				</CardContent>
			</Card>
		</Grid>
	);
};
